import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SearchBulkState } from '../models/bulk.models';
import * as selectors from '../selectors/search-bulk.selectors';

@Injectable({ providedIn: 'root' })
export class SearchBulkFacadeService extends FacadeService {
  constructor(public override store: Store<SearchBulkState>) {
    super(store);
  }

  panelExpanded$ = this.storeSelect(selectors.getPanelExpansion);
  profileModel$ = this.storeSelect(selectors.getProfileModel);
  profileModelValues$ = this.storeSelect(selectors.getProfileModelValues);
  configurationName$ = this.storeSelect(selectors.getConfigurationName);
  isActive$ = this.storeSelect(selectors.getIsActive);

  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get profileModel() {
    return this.storeSnapshot(this.profileModel$);
  }

  get configurationName() {
    return this.storeSnapshot(this.configurationName$);
  }

  get isActive() {
    return this.storeSnapshot(this.isActive$);
  }

  get profileModelValues() {
    return this.storeSnapshot(this.profileModelValues$);
  }
}
